import { render } from "./ModalBody.vue?vue&type=template&id=9d7f94a6&scoped=true"
import script from "./ModalBody.vue?vue&type=script&lang=js"
export * from "./ModalBody.vue?vue&type=script&lang=js"

import "./ModalBody.vue?vue&type=style&index=0&id=9d7f94a6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-9d7f94a6"

export default script